<template>
  <div class="Header1">
    <div class="top-bar">
      <Sf-header class="sf-header--has-mobile-search header-searchBar" :class="{
          'header-on-top': isSearchOpen,
          'mobile-header': isMobile,
          itemsWeizhi: !hiddenItemSearch,
          mobileSearchHome: isMobile && hiddenCurrency,
        }" :isNavVisible="isMobileMenuOpen">
        <template #logo>
          <nuxt-link :to="localePath({ name: 'home' })" class="sf-header__logo">
            <SfImage v-if="Icon" :src="Icon" :alt="storeTitle" class="sf-header__logo-image" :width="34" :height="34"
              @click="closeSearch" :loading='"eager"' />
            <div style="width: 32px; height: 32px" v-if="!Icon"></div>
          </nuxt-link>
        </template>
        <template #navigation>
          <HeaderNavigation :isMobile="isMobile" @back="closeSearch" />
        </template>
        <template #aside>
          <div style="display: flex; align-items: center">
            <LocaleSelector @click:open="closeSearch" class="smartphone-only" />
            <CurrenciesSelector v-if="hiddenCurrency" @click:open="closeSearch" class="smartphone-only" />
          </div>
        </template>
        <template #header-icons>
          <div v-if="!isAuthenticated" v-e2e="'header-icons'" class="sf-header__icons">
            <SfButton v-if="hiddenLogin && !isMobile" class="sf-button--pure sf-header__action"
              aria-label="Open account button" :style="bgColor" @click="handleLoginClick">
              <SfIcon icon="profile" size="1.25rem" />
            </SfButton>
            <LocaleSelector class="sf-button--pure sf-header__action buttonICon" />
            <CurrenciesSelector v-if="hiddenCurrency" class="sf-button--pure sf-header__action buttonICon" />
          </div>
          <div v-if="isAuthenticated" v-e2e="'header-icons'" class="sf-header__icons">
            <SfButton v-if="!isMobile" class="sf-button--pure sf-header__action" :style="bgColor"
              aria-label="Open account button" @click="handleAccountClick">
              <SfIcon :icon="accountIcon" size="1.25rem" />
            </SfButton>
            <SfButton v-if="!isMobile" class="sf-button--pure sf-header__action" :style="bgColor"
              aria-label="Toggle wishlist sidebar" @click="toggleWishlistSidebar">
              <SfIcon class="sf-header__icon" icon="heart" size="1.25rem" />
            </SfButton>
            <SfButton v-if="!isMobile" class="sf-button--pure sf-header__action" :style="bgColor"
              aria-label="Toggle cart sidebar" @click="toggleCartSidebar">
              <SfIcon class="sf-header__icon" icon="empty_cart" size="1.25rem" />
              <SfBadge v-if="cartTotalItems" class="sf-badge--number cart-badge">{{ cartTotalItems }}</SfBadge>
            </SfButton>
            <!-- 站内信 -->
            <SfButton v-if="!isMobile&&isAuthenticated" class="sf-button--pure sf-header__action" :style="bgColor"
              aria-label="Toggle wishlist sidebar" @click="toggleMessageSidebar">
              <SfIcon class="sf-header__icon" icon="message" size="1.25rem" />
              <div class="dian" v-if="unReadNum"></div>
            </SfButton>
            <SfButton v-if="!isMobile" class="sf-button--pure sf-header__action" :style="bgColor"
              aria-label="Logout button" @click="handleLogoutClick">
              <SfIcon icon="logout" size="1.25rem" />
            </SfButton>
            <LocaleSelector class="sf-button--pure sf-header__action buttonICon" />
            <CurrenciesSelector v-if="hiddenCurrency" class="sf-button--pure sf-header__action buttonICon" />
          </div>
        </template>
        <template #search>
          <SfSearchBar v-if="hiddenItemSearch" ref="searchBarRef" :style="bgColor" class="searchInput"
            :placeholder="$t('Search_items')" aria-label="Search" :value="term" @keydown.esc="closeSearch"
            @keydown.enter="handleSearch($event)">
            <template #icon>
              <SfButton v-if="!!term" aria-label="Close search" class="sf-search-bar__button sf-button--pure"
                @click="closeOrFocusSearchBar">
                <span class="sf-search-bar__icon">
                  <SfIcon color="var(--c-text)" size="18px" icon="cross" />
                </span>
              </SfButton>
            </template>
          </SfSearchBar>
          <div v-else style="flex: 1"></div>
        </template>
      </Sf-header>
    </div>
    <SearchResults :visible="isSearchItemOpen" :result="result" :term="term" @close="closeSearch"
      @removeSearchResults="removeSearchResults" />
    <SfOverlay :visible="isSearchItemOpen" @click="closeSearch" class="searchOverlay" style="z-index:9" />
  </div>
</template>

<script>
import {
  SfHeader,
  SfImage,
  SfIcon,
  SfButton,
  SfBadge,
  SfSearchBar,
  SfOverlay
} from '@storefront-ui/vue';
import { useUiState } from '~/composables';
import {
  useOCart,
  useUser,
  cartGetters,
  useFacet,
  userMessage,
  useGoodsSearch,
  useGuest
} from '@bee-hole/coms';
import { computed, ref, watch, useRouter, onMounted } from '@nuxtjs/composition-api';
import { useUiHelpers } from '~/composables';
import LocaleSelector from './LocaleSelector';
import CurrenciesSelector from './CurrenciesSelector';
import SearchResults from '~/components/SearchResults';
import HeaderNavigation from './HeaderNavigation';
import { clickOutside } from '@storefront-ui/vue/src/utilities/directives/click-outside/click-outside-directive.js';
import debounce from 'lodash.debounce';
import { addBasePath } from '@vue-storefront/core';
import { useCustomerStore } from '~/stores/customer';
import { hexToRGBA } from '@/plugins/utils';
export default {
  components: {
    SfHeader,
    SfImage,
    LocaleSelector,
    SfIcon,
    SfButton,
    SfBadge,
    SfSearchBar,
    SearchResults,
    SfOverlay,
    HeaderNavigation,
    CurrenciesSelector
  },
  directives: { clickOutside },
  setup(props, { root }) {
    const api = 'searchGoods';
    const router = useRouter();
    const { setToken, login: guestLogin, guest } = useGuest();
    const customerStore = useCustomerStore();
    const {
      toggleCartSidebar,
      toggleWishlistSidebar,
      toggleLoginModal,
      isMobileMenuOpen,
      isMobile,
      isSearchItemOpen,
      toggleSearchItem,
      toggleMessageSidebar,
      isLoginModalOpen
    } = useUiState();
    // getFacetsFromURL
    const { setTermForUrl } = useUiHelpers();
    const { isAuthenticated, logout, load: loadUser } = useUser();
    // const { result: catRes, search: searchList } = useFacet('search-goods');
    const { cart } = useOCart();
    const { unReadMsg, unResult, readMsg, readResult } = userMessage();
    const { search: searchProduct, goodsResult } = useGoodsSearch('search-goods');
    const { result: catRes, search: searchList } = useFacet('search-goods');
    const hiddenItemSearch = computed(() => {
      return !root?.$options?.$mallConfig?.mall_web_config?.hidden_item_search;
    });
    const hiddenLogin = computed(() => {
      return !root?.$options?.$mallConfig?.mall_web_config?.hidden_login;
    });
    const hiddenCurrency = computed(() => {
      return !root?.$options?.$mallConfig?.mall_web_config?.hidden_currency;
    });
    const bgColor = computed(() => {
      if (root?.$options?.$storeConfig?.mall_home_type === 'website') {
        const config = root?.$options?.$mallConfig?.mall_home_artice;
        // js #fff 转成rgba
        if (
          config?.headerBgColor?.indexOf('rgb') !== -1 &&
          config?.headerBgColor?.indexOf('rgb') !== undefined
        ) {
          return { background: config?.headerBgColor || '#ffffff' };
        } else {
          return {
            background: hexToRGBA(config?.headerBgColor || '#ffffff', 0.5)
          };
        }
      } else {
        return {};
      }
    });
    const term = ref();
    const isSearchOpen = ref(false);
    const searchBarRef = ref(null);
    const result = ref(null);
    const storeTitle = computed(
      () => root?.$options?.$mallConfig?.mall_web_config?.title || ''
    );
    const Icon = computed(() => {
      if (root?.$options?.$mallConfig?.mall_web_config) {
        return root?.$options?.$mallConfig?.mall_web_config?.link?.[0]?.href;
      } else {
        return null;
      }
    });
    // const {isMobile}=useUiState();
    // const goods = computed(() => catRes?.value?.data?.list);
    const cartTotalItems = computed(() => {
      const count = cartGetters.getTotalItems(cart.value);
      return count ? count?.toString() : null;
    });

    const accountIcon = computed(() =>
      isAuthenticated.value ? 'profile_fill' : 'profile'
    );

    // TODO: https://github.com/DivanteLtd/vue-storefront/issues/4927

    const handleLogoutClick = async () => {
      await logout();
      const localeAccountPath = root.localePath({ name: 'home' });
      return router.push(localeAccountPath);
    };

    const closeSearch = () => {
      const wishlistClassName = 'sf-product-card__wishlist-icon';
      const isWishlistIconClicked = event?.path?.find(
        (p) => wishlistClassName.search(p.className) > 0
      );
      if (
        isWishlistIconClicked ||
        !isSearchOpen.value ||
        !isSearchItemOpen.value
      )
        return;
      term.value = '';
      isSearchOpen.value = false;
      toggleSearchItem();
    };

    const handleSearch = debounce(async (paramValue) => {
      if (paramValue && !paramValue.target) {
        term.value = paramValue;
      } else if (paramValue && paramValue.target) {
        term.value = paramValue.target.value;
      }
      if (term.value) {
        if (api === 'useFacet') {
          await searchList({ q: term.value, page: 1, limit: 10 });
        } else {
          await searchProduct({ title: term.value, page: 1, limit: 12 });
        }
        // console.log(' term.value term.value', term.value, catRes);
        // if (goodsResult?.value?.list) {
        if (catRes?.value?.data?.list) {
          if (!result.value) {
            result.value = {};
          }
          if (!isSearchItemOpen.value) {
            toggleSearchItem();
          }
          // result.value.categories = []
          // result.value.products = goods.value;
          // console.log('列表', mockedSearchProducts, goods);
        }
      }
    }, 1000);

    const closeOrFocusSearchBar = () => {
      if (isMobile.value) {
        // return closeSearch();
        term.value = '';
      } else {
        term.value = '';
        // return searchBarRef.value.$el.children[0].focus();
      }
    };

    watch(
      () => term.value,
      (newVal, oldVal) => {
        const shouldSearchBeOpened =
          // !isMobile.value &&
          term.value?.length > 0 &&
          ((!oldVal && newVal) ||
            (newVal?.length !== oldVal?.length &&
              isSearchItemOpen.value === false));
        if (shouldSearchBeOpened) {
          isSearchOpen.value = true;
          toggleSearchItem();
        }
      }
    );

    const handleAccountClick = async () => {
      closeSearch();
      if (isAuthenticated.value) {
        const localeAccountPath = root.localePath('/my-account/History?open=1');
        return router.push(localeAccountPath);
      }
      toggleLoginModal();
    };
    const handleLoginClick = async () => {
      closeSearch();
      toggleLoginModal();
    };

    const removeSearchResults = () => {
      result.value = null;
    };
    const gusetLogin = async () => {
      await guestLogin();
      if (guest.value?.token) {
        const tokenkey = root?.$cookies.get("tokenkey");
        if (tokenkey && !customerStore?.isSetToken && guest.value?.token) {
          await setToken({ key: tokenkey });
          customerStore.setisSetToken(true);
        }
        if (isLoginModalOpen.value) {
          toggleLoginModal();
        }
        await loadUser();
      }
    };
    const RegistrySettings = computed(() => root?.$options?.$storeConfig?.mall_registry_settings || { email: { enable: false }, phone: { enable: false }, is_guest: false });
    onMounted(() => {
      if (RegistrySettings.value.is_guest && !root?.$cookies.get('token')) {
        gusetLogin();
      }
    });
    return {
      isAuthenticated,
      accountIcon,
      cartTotalItems,
      handleAccountClick,
      handleLoginClick,
      handleLogoutClick,
      toggleCartSidebar,
      toggleWishlistSidebar,
      toggleMessageSidebar,
      setTermForUrl,
      term,
      isSearchOpen,
      closeSearch,
      handleSearch,
      result,
      closeOrFocusSearchBar,
      searchBarRef,
      isMobile,
      isMobileMenuOpen,
      removeSearchResults,
      addBasePath,
      Icon,
      isSearchItemOpen,
      storeTitle,
      hiddenItemSearch,
      hiddenLogin,
      hiddenCurrency,
      bgColor,
      unReadNum: computed(() => unResult.value?.unread_total_count || 0)
    };
  }
};
</script>
<style lang="scss">
.dian {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #f00;
  margin-bottom: 10px;
}
.Header1 {
  z-index: 9999999999;
  position: relative;
  .sf-header--has-mobile-search {
    .sf-image--placeholder {
      display: none;
    }
  }
  // position: relative;
  .sf-header__header {
    background-color: rgb(255, 255, 255, 0);
  }
  .searchOverlay{
    --overlay-z-index: 1 !important;
  }
}
.searchInput {
  text-align: left;
  @include for-mobile{
    max-width: 60vw;
  }
}
@media (min-width: 1024px) {
  .sf-search-bar {
    width: auto !important;
    margin-left: 1rem;
  }
}

@media (max-width: 1024px) {
  .sf-search-bar {
    --search-bar-width: 100%;
    margin-left: 0;
  }
}

.header-searchBar {
  z-index: 1;
  .sf-header__logo {
    position: relative;
    min-width: 34px;
  }
  .sf-header__search {
    flex: 0 1 18rem;
  }
  @include for-desktop {
    padding: var(--spacer-sm) 0;
  }
}

.sf-search-bar.sf-input input:focus {
  outline: none;
}

.sf-header {
  --Link-justify-content: flex-end;
}

.itemsWeizhi {
  --Link-justify-content: flex-start;
  --header-icons-margin: 0 0 0 auto;
}

.mobile-header {
  --_image-height: 34px;
  --_image-width: 34px;
  --header-icons-display: flex;
  .sf-header__header {
    display: flex;
    gap: 15px;
    .sf-header__aside {
      display: none;
    }
    .sf-header__actions {
      flex: 1;
      // position: absolute;
      .sf-search-bar {
        flex: 1;
      }
      .sf-header__icons {
        display: flex !important;
        gap: 15px !important;
        margin-left: 15px !important;
      }
      .buttonICon {
        margin-left: 0 !important;
      }
      @media (max-width: 1024px) {
        margin-left: 0;
        // left:34px;
      }
    }
  }

  .sf-header__wrapper {
    box-shadow: none;
  }
}
.mobileSearchHome {
  .sf-header__actions {
    flex: 1;
    width: 50% !important;
  }
}
.sf-header__actions {
  justify-content: var(--Link-justify-content);
}

@media (min-width: 1024px) {
  .sf-header__navigation {
    display: flex;
    --header-navigation-margin: 0 var(--spacer-base) 0 var(--spacer-base);
    order: 0;
    flex: 0 0 auto;
  }
}
@include for-desktop {
  .Header1 {
    height: 2rem;
    .top-bar {
      position: absolute;
      top: 0;
      width: 100%;
      text-align: center;
    }
  }
}
@include for-mobile {
  .sf-header__logo-image {
    max-width: 80px;
    .sf-image {
      max-width: 80px;
      object-fit: contain !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.Header1
  .header-searchBar
  .sf-header__wrapper
  .sf-header__header
  .sf-header__icons
  .sf-header__action {
  margin: var(--header-action-margin, 0 0 0 var(--spacer-base));
}

.buttonICon {
  margin: var(--header-action-margin, 0 0 0 var(--spacer-base));
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sf-header {
  --header-padding: var(--spacer-sm);

  @include for-desktop {
    --header-padding: 0;
  }

  &__logo-image {
    height: 100%;
  }
}

.sf-search-bar.sf-input input:focus {
  outline: none;
}

.header-on-top {
  z-index: 2;
}

.nav-item {
  --header-navigation-item-margin: 0 var(--spacer-base);

  .sf-header-navigation-item__item--mobile {
    display: none;
  }
}

.cart-badge {
  position: absolute;
  bottom: 40%;
  left: 40%;
}
</style>
